import { produce } from 'immer'
import { TimerState, TimerActions, TimerActionTypes } from './types'

const INITIAL_STATE: TimerState = {
  status: 'idle',
  mode: 'card',
  currentSessionId: null,
  startTimestamp: null,
  pauseTimestamp: null,
  pauseDuration: 0,
  pauseStartTimestamp: null,
  addedTime: 0,
  initialDuration: 0,
  isVisible: false,
}

const timerReducer = (state = INITIAL_STATE, action: TimerActions): TimerState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case TimerActionTypes.START_TIMER: {
        draft.status = 'running'
        draft.currentSessionId = action.payload.sessionId
        draft.initialDuration = action.payload.duration
        draft.startTimestamp = Date.now()
        draft.pauseTimestamp = null
        draft.pauseDuration = 0
        draft.pauseStartTimestamp = null
        draft.addedTime = 0
        draft.isVisible = true
        break
      }

      case TimerActionTypes.PAUSE_TIMER: {
        if (draft.status === 'running') {
          draft.status = 'paused'
          draft.pauseTimestamp = Date.now()
          draft.pauseStartTimestamp = Date.now()
        }
        break
      }

      case TimerActionTypes.RESUME_TIMER: {
        if (draft.status === 'paused' && draft.pauseStartTimestamp) {
          draft.status = 'running'
          const pauseElapsed = Date.now() - draft.pauseStartTimestamp
          draft.pauseDuration += pauseElapsed
          draft.pauseStartTimestamp = null
        }
        break
      }

      case TimerActionTypes.STOP_TIMER: {
        draft.status = 'stopped'
        break
      }

      case TimerActionTypes.RESET_TIMER: {
        return INITIAL_STATE
      }

      case TimerActionTypes.RESTART_TIMER: {
        draft.status = 'idle'
        draft.startTimestamp = null
        draft.pauseTimestamp = null
        draft.pauseDuration = 0
        draft.pauseStartTimestamp = null
        draft.addedTime = 0
        // Mantém: currentSessionId, initialDuration, mode, isVisible
        break
      }

      case TimerActionTypes.ADD_TIME: {
        draft.addedTime += action.payload
        break
      }

      case TimerActionTypes.TOGGLE_MODE: {
        draft.mode = draft.mode === 'card' ? 'fullscreen' : 'card'
        break
      }

      case TimerActionTypes.SET_VISIBILITY: {
        draft.isVisible = action.payload
        break
      }

      default:
        return state
    }
  })
}

export default timerReducer
